export default {
  get_all: { method: 'get', url: 'api/counties' },
  show: { method: 'get', url: 'api/counties{/id}' },
  store: { method: 'post', url: 'api/counties' },
  update: { method: 'put', url: 'api/counties{/id}' },
  delete: { method: 'delete', url: 'api/counties{/id}' }
}
